import mutations from './additionalExamination.mutations'
import actions from './additionalExamination.actions'
import getters from './additionalExamination.getters'

import initialState from './defaultState'

const state = initialState();

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}
